import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getCasinoGames, getSlotGameData } from '../../store/actions/casino.actions';
import Game from '../Casino/Game';
import NewLoading from '../../Components/Common/NewLoading';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingIcon from '../../Components/Common/LoadingIcon';
import Login from '../Login';
import Categories from './Categories';

const NewGames = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [showLogin, setShowLogin] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);
    const { filteredCasinoGames, casinoSearchValue, filteredGamesCount, loadingCasinoGames } = useSelector((state) => state.casino);
    const userData = useSelector((state) => state.user.data);

    useEffect(() => {
        let filters = {
            search: casinoSearchValue,
            category: 'LIVECASINO',
            page: page,
            size: 20,
            latest: true
        };
        dispatch(getCasinoGames(filters));
    }, [page, casinoSearchValue]);

    const hideLogin = () => {
        setShowLogin(false);
    };

    const fetchMore = () => {
        if (filteredCasinoGames.length == filteredGamesCount) setHasMore(false);
        setPage(page + 1);
    };

    const isLoggedIn = () => {
        return userData !== null;
    };

    const playGame = (game, type) => {
        if (type == 'demo') {
            if (game?.demoSupport) {
                dispatch(getSlotGameData(game, type, history));
            } else {
                toastr.info('Please try another game this game dosn\'t support demo mode');
            }
        } else if (isLoggedIn()) {
            dispatch(getSlotGameData(game, type, history));
        } else {
            sessionStorage.setItem('gameData', JSON.stringify(game));
            setShowLogin(true);
        }
    };

    let gameList =
        filteredCasinoGames && filteredCasinoGames.length > 0
            ? filteredCasinoGames.map((game) => {
                return <Game game={game} playGame={playGame} />;
            })
            : [];

    return (loadingCasinoGames ? (
        <NewLoading customClass="casino-loader" />
    ) : filteredCasinoGames.length > 0 ? (
        <div className='pt-4 most-pupolar' id='scrollableDiv'>
            <Categories />
            <div className="casino-game-parent pl-40 pr-40 clearfix mb-2">
                <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade show active casino-box">
                        <div>
                            <InfiniteScroll
                                dataLength={filteredCasinoGames.length}
                                next={() => fetchMore()}
                                loadMore={() => fetchMore()}
                                hasMore={hasMore}
                                useWindow={false}
                                loader={<LoadingIcon theme="dark centered" />}
                                scrollableTarget="infinite-div"
                                threshold={7}
                                scrollThreshold={0.7}
                            >
                                <ul>{gameList}</ul>
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            </div>
            {showLogin && <Login hideLogin={hideLogin} history={history}/>}
        </div>
    ) : (
        <div className="fs-15 pt-3 pb-3 text-white">Nothing Found</div>
    ));
};

export default NewGames;